module.exports = __webpack_public_path__ + "static/img/1.813321b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/1.png
// module id = Oe1C
// module chunks = 0